<template>
  <a v-if="conflict_string.length" href="#" class="d-inline-block ps-2" data-bs-toggle="tooltip" data-bs-html="true" data-bs-placement="right" :title="conflict_string">
    <span class="badge badge-phoenix fs--2 badge-phoenix-warning">
        <span class="badge-label">Overlap&nbsp;</span>
        <vue-feather class="badge-icon" type="layers"></vue-feather>
    </span>
  </a>
</template>

<script>
import * as bootstrap from 'bootstrap'
import VueFeather from 'vue-feather'

export default {
    name: 'SessionTimeConflict',
    components: {
        VueFeather,
    },
  created(){
      if(this.conflicts.length >= 1){
            this.conflict_string = this.conflicts.map( (x) => x.name)
            this.conflict_string = this.conflict_string.join('<br>')
            this.conflict_string = "Overlaps with:<br>" + this.conflict_string
          }
    },
  mounted() {
    let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    tooltipTriggerList.map(function (tooltipTriggerEl) {
          return new bootstrap.Tooltip(tooltipTriggerEl)
        })
  },
  data() {
        return {
          conflict_string: '',
          css_class: 'd-hidden'
        }
    },
    props: {
        conflicts: {
            type: Array,
            default: new Array(),
        },
    },
}

</script>
